import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ts1 from "../../images/testimonial/img-1.jpg";
import ts2 from "../../images/testimonial/img-2.jpg";
import ts3 from "../../images/testimonial/img-3.jpg";

class Testimonial extends Component {
  render() {
    var settings = {
      dots: false,
      arrows: true,
      speed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const testimonial = [
      {
        tsImg: ts1,
        Des: "Possui ampla experiência como mentora de diretores e executivos no Brasil e na Europa, onde trouxe insights valiosos para alinhar meus objetivos profissionais e traçar um melhor direcionamento de carreira. Destaco a habilidade única de identificar pontos de melhoria e potencial, sempre com muita empatia e assertividade. Recomendo fortemente para quem busca crescimento e resultados concretos!",
        Title: "Jessé",
        Sub: "",
      },
      {
        tsImg: ts2,
        Des: "Tive a oportunidade de conhecer a Thomas Talent através de uma recomendação de alguém que já havia colhido os frutos positivos da consultoria. Inicialmente, eu não buscava esse tipo de orientação profissional, mas me surpreendi com o impacto das melhorias que implementamos juntos. Neste mês, consegui realizar minha transição para uma empresa de destaque, com um excelente salário e desafios enriquecedores. Os aprendizados vão desde comportamentos humanos até estratégias corporativas, garantindo minha aderência ao mercado.",
        Title: "Andrew",
        Sub: "",
      },
      {
        tsImg: ts3,
        Des: "Excelente profissional! Katiane é uma profissional ímpar do mercado. Extremamente competente, responsável e sempre presente. Nunca deixa de responder minhas dúvidas e está sempre à disposição. Sou muito grato por encontrar uma profissional tão ética e talentosa em meu caminho. Só tenho a agradecer e recomendar aos demais profissionais.",
        Title: "Renan",
        Sub: "",
      },
      {
        tsImg: ts1,
        Des: "Estou em transição de carreira e busquei uma consultoria que pudesse me orientar nesse momento. Através de uma indicação conheci a Katiane — que sorte a minha 🙏. O atendimento foi excelente: super atenciosa e muito profissional. A Katiane me fez enxergar um potencial que estava guardado e que eu não sabia que tinha. O passar do tempo na carreira pode nos colocar em uma zona de conforto que freia nosso crescimento, e é nesse momento que encontrar profissionais como a Katiane faz toda a diferença — e fez! Obrigada por sua disponibilidade e orientação. Começamos uma parceria que será muito duradoura!",
        Title: "Jackeline",
        Sub: "",
      },
      {
        tsImg: ts1,
        Des: "Recomendo a Thomas Talent: uma equipe excelente e profissional, que entende a necessidade e o momento do cliente. Sempre dá retorno em curto espaço de tempo. O ótimo relacionamento que a Katiane e a equipe têm com o mercado facilita muito o trânsito com as pessoas e processos, além de identificar nossos pontos fortes e pontos de melhoria. É uma empresa sempre disposta a ajudar e com alto astral. Super recomendo a toda a minha rede que esteja pensando em transição de carreira, iniciando uma nova trajetória ou buscando o primeiro emprego. Muito sucesso, Katiane e equipe. Continuem sempre assim!",
        Title: "Katia",
        Sub: "",
      },
      {
        tsImg: ts1,
        Des: "Tive a grata oportunidade de receber mentoria da Katiane durante um período recente de transição de carreira, e gostaria de recomendá-la pelo alto grau de profissionalismo e objetividade com que me assessorou. Sempre muito acessível, clara e transparente em seus feedbacks e orientações, com alto grau de empatia e gentileza. Katiane é muito experiente e conhece bem o mercado e o comportamento humano, compreendendo com sensibilidade meu momento. Suas dicas e conselhos foram preciosos para que eu desenvolvesse meu próprio método de captação de posições no mercado e me preparasse para essa transição, tanto no aspecto técnico quanto psicológico. Agradeço muito pelo aprendizado, mentoria e torcida!",
        Title: "Ana",
        Sub: "",
      },
    ];

    return (
      <section
        className={`wpo-testimonial-section section-padding ${this.props.tClass}`}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="wpo-testimonial-title">
                <h2>
                  <i className="fi flaticon-left-quote"></i> O que{" "}
                  <span>nossos clientes</span> estão falando
                </h2>
              </div>
            </div>
          </div>
          <div className="wpo-testimonial-items wpo-testimonial-slider owl-carousel">
            <Slider {...settings}>
              {testimonial.map((tesmnl, tsm) => (
                <div className="wpo-testimonial-item" key={tsm}>
                  <h3>{tesmnl.Title}</h3>
                  <div className="wpo-testimonial-text">
                    <h3 className="fs-4 fw-light">{tesmnl.Des}</h3>
                    <div className="wpo-testimonial-text-btm">
                      <span>{tesmnl.Sub}</span>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default Testimonial;
